<template>
  <ModalDialog
    ref="dialog"
    :title="title"
    :submitting="submitting"
    :submitTitle="submitTitle"
    icon="fa-usd-circle"
    @closed="onClosed"
    @submitted="onSubmitted">

    <FormGroup v-bind:form="currencyForm" :labelColumnSize="3">
      <FormRow label="Account Currency"><FormStaticLabel>{{accountCurrencyCode}}</FormStaticLabel></FormRow>
      <FormRow label="Currency Code"><FormInputText placeholder="Code" v-model="currency.targetCode" field="targetCode" /></FormRow>
      <FormRow label="Use Market Rate"><FormCheckbox v-model="currency.useMarketRate" field="useMarketRate" /></FormRow>
      <FormRow label="Rate" v-if="!currency.useMarketRate"><FormInputCurrency placeholder="Rate" v-model="currency.rate" field="rate" /></FormRow>
    </FormGroup>
  </ModalDialog>
</template>

<script>
import _ from 'lodash'
import { mapState } from 'vuex'

import form from '@/mixins/form'
import ModalDialog from '@/components/modalDialog.vue'
import ModalDialogMixin from '@/mixins/modalDialog'

export default {
  name: "CurrencyEditDialog",
  mixins: [
    ModalDialogMixin,
    form
  ],
  components: {
    ModalDialog
  },
  props: {
    isCreateMode: Boolean
  },
  data() {
    return {
      currencyId: null,
      currency: {},
      currencyForm: {},
      submitting: false
    }
  },
  mounted() {
  },
  computed: {
    title() {
      return this.isCreateMode ? 'New Currency' : 'Edit Currency'
    },
    submitTitle() {
      return this.isCreateMode ? 'Create' : 'Update'
    },
    ...mapState({
      accountCurrencyCode: state => state.account.currencyCode,
    })
  },
  methods: {
    show(currency) {
      // Reset form
      this.currency = {
        useMarketRate: false
      }
      this.currencyId = 0
      this.currencyForm = {}
      this.submitting = false

      if(currency != null) {
        this.currency = _.cloneDeep(currency)
        this.currencyId = currency.id
      }

      return ModalDialogMixin.methods.show.call(this, arguments)
    },
    onClosed() {
      this.modalClosed(false)
    },
    onSubmitted() {
      this.submitting = true

      var currencyData = _.cloneDeep(this.$data.currency)

      if(this.isCreateMode) {
        this.$apiService.adminService.createCurrency(currencyData)
        .then(() => {
          this.submitting = false
          this.modalClosed(true)
          this.hide()
        })
        .catch(err => {
          this.submitting = false
          this.$data.currencyForm = this.processFormResponse(err)
        })
      } else {
        this.$apiService.adminService.updateCurrency(this.currencyId, currencyData)
        .then(() => {
          this.submitting = false
          this.modalClosed(true)
          this.hide()
        })
        .catch(err => {
          this.submitting = false
          this.$data.currencyForm = this.processFormResponse(err)
        })
      }
    }
  }
}
</script>